import { render, staticRenderFns } from "./SalesOrderSelector.vue?vue&type=template&id=566cc0c6"
import script from "./SalesOrderSelector.vue?vue&type=script&lang=js"
export * from "./SalesOrderSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports